<div class="p-grid">
  <div class="p-col-12 p-sm-12 p-md-12 p-lg-12 p-xl-12 p-px-2 p-px-sm-2 p-px-md-2 p-px-lg-2 p-px-xl-2">

    <p-panel [collapsed]="false" [toggleable]="true">
      <ng-template pTemplate="header">
        <p class="p-m-0" style="color: #232c70">
          <b>Resumen</b> <small class="p-ml-2 p-text-light">Presiona en el ícono para mostrar/ocultar el
            contenido</small>
        </p>
      </ng-template>
      <div>
        Aquí se muestra información relacionada con tus cursos y postulaciones.
        <div class="p-grid p-jc-center p-py-6">
          <div class="p-col p-d-flex p-flex-column p-text-center" style="align-items: center;">
            <div *ngIf="!loadingPostulaciones || !loadingPostulacionesAceptadas" class="p-circle p-mb-2">
                <p>{{numPostulacionesAceptadas}} de {{numPostulaciones}}</p>
            </div>
            <p-progressSpinner *ngIf="loadingPostulaciones || loadingPostulacionesAceptadas"></p-progressSpinner>
            <p class="p-m-0"><small>Postulaciones</small><br><small>aceptadas</small></p>
          </div>

          <div class="p-col p-d-flex p-flex-column p-text-center" style="align-items: center;">
            <div *ngIf="!loadingPostulacionesMes" class="p-circle p-mb-2">
                <p>{{numPostulacionesMes}}</p>
            </div>
            <p-progressSpinner *ngIf="loadingPostulacionesMes"></p-progressSpinner>
            <p class="p-m-0"><small>Postulaciones</small><br><small>este mes</small></p>
          </div>

          <div class="p-col p-d-flex p-flex-column p-text-center" style="align-items: center;">
            <div *ngIf="!loadingCursosEnProgreso" class="p-circle p-mb-2">
                <p>{{numCursosEnProgreso}}</p>
            </div>
            <p-progressSpinner *ngIf="loadingCursosEnProgreso"></p-progressSpinner>
            <p class="p-m-0"><small>Cursos</small><br><small>en progreso</small></p>
          </div>
          

          <div class="p-col p-d-flex p-flex-column p-text-center" style="align-items: center;">
            <div *ngIf="!loadingCertificados" class="p-circle p-mb-2">
                <p>{{numCertificadosAlumno}}</p>
            </div>
            <p-progressSpinner *ngIf="loadingCertificados"></p-progressSpinner>
            <p class="p-m-0"><small>Certificados</small><br><small>obtenidos</small></p>
          </div>

          
        </div>
      </div>
    </p-panel>

    <p-panel [collapsed]="true" [toggleable]="true">
      <ng-template pTemplate="header">
        <p class="p-m-0" style="color: #232c70">
          <b>Videos tutoriales</b> <small class="p-ml-2 p-text-light">Presiona en el ícono para mostrar/ocultar el
            contenido</small>
        </p>
      </ng-template>
      <div class="p-grid">
        <div class="p-col-12 p-sm-6 p-md-6 p-lg-6 p-xl-6 videos" *ngFor="let video of videos">
          <iframe class="youtube-player" width="100%" height="200" [src]="video.url" title="Video tutorial Educación Continua" frameborder="0" allowfullscreen></iframe>
        </div>
      </div>
    </p-panel>

  </div>
</div>